import { createAxiosHttp } from "./createHttpRequest";
import { IResult, ILoginResult } from "../interface/index";
import { AxiosRequestHeaders } from "axios";

export class ApiCore {
  //登录接口
  login = (params: { passWord: string; userCode: string }) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: "/plat/user/login",
      data: params,
    });

  //人脸签约检查
  faceSign = (params: { userCode: string }) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: "/plat/user/faceSign",
      data: params,
    });

  //获取待处理任务列表
  getTasks = (params: {
    page?: number;
    pageSize?: number;
    projectCode?: any;
    type?: any;
    subjectCode?: any;
    subjectCodeOrder?: any;
  }) =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: "/data/tasks",
      params: params,
    });

  //获取待处理任务列表new
  getTasksList = (params: {
    page?: number;
    pageSize?: number;
    projectCode?: any;
    type?: any;
    subjectCode?: any;
    subjectCodeOrder?: any;
    displayType?: any;
  }) =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: "/data/tasks/list",
      params: params,
    });

  //获取用户当前的项目
  getProject = () =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: "/project/projects",
      // data: params
    });

  // 受试者工作台统计
  getDataCRCStatistic = (params: { projectCode: any }) =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/balance/task/crc/statistic/${params.projectCode}`,
    });

  // 根据项目code列表获取项目名称
  getSubjectStatistics = (params: any) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: `/project/subject/statistics/display?projectCode=${
        params.projectCode || ""
      }`,
    });

  //根据id获取受试者首页数据
  getSubjectdDetail = (params: { id: any }) =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/data/subject/${params.id}`,
    });

  //根据访视id获取表单列表
  getFormsById = (params: { id: string }) =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/data/visit/${params.id}`,
    });

  //根据任务类型获取访视详情
  getVisitsByType = (params: { subjectCode: string; type: string }) =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/data/subject/${params.subjectCode}/visits/${params.type}`,
    });

  //受试者提交审核
  submitAudit = (params: { code: string }) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: `/data/subject/audit/submit/${params.code}`,
    });

  //根据表单id获取具体表单模板
  getFormTemplateById = (params: { id: string }) =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/data/form/${params.id}`,
    });

  //根据项目id获取所属中心列表
  getCenterByProjectId = (params: { name?: string; projectId: string }) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: `/project/center/${params.projectId}/centers`,
    });

  //根据项目id获取项目分组配置
  getGroupByProjectId = (params: { projectCode: string }) =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/project/groupConfig`,
      params: params,
    });
  //添加受试者
  addSubject = (params: {
    centerCode: string;
    projectCode: string;
    subjectCode: string;
    groupCode: string;
  }) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: "/data/subject",
      data: params,
    });
  //受试者入组
  subjectJoin = (params: { id: string }) =>
    createAxiosHttp<IResult<any>>({
      method: "patch",
      url: `/data/subject/join/${params.id}`,
    });

  //受试者排除
  subjectPass = (params: { id: string }) =>
    createAxiosHttp<IResult<any>>({
      method: "patch",
      url: `/data/subject/pass/${params.id}`,
    });

  //保存表单
  saveForm = (params: {
    formId: string;
    submit: boolean;
    values: Array<any>;
  }) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: "/data/data",
      data: params,
    });
  //修改数据

  updateData = (params: {
    formId: string;
    dataCode: string;
    deCode: string;
    value: any;
  }) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: "/data/data/update",
      data: params,
    });

  
  updateDatas = (params: {
    formId: string;
    values: Array<any>;
  }) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: "/data/data/updates",
      data: params,
    });
    //判断是否能 删除表单数据，关于结算
  isDisableDelete = (params: { formId: string; values: Array<any> }) => 
     createAxiosHttp<IResult<any>>({
      method: "post",
      url: "/data/subject/form/delete",
      data: params,
  });
  
  //删除表单数据
  deleteData = (params: { formId: string; values: Array<any> }) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: "/data/invalid",
      data: params,
    });
  //获取注解类型
  getAnnotationType = () =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: "/data/data/annotation/types",
    });
  //数据注解
  annotationData = (params: {
    formId: string;
    dataCode: string;
    deCode: string;
    annotation: string;
  }) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: "/data/data/annotation",
      data: params,
    });
  //数据备注
  remarkData = (params: {
    formId: string;
    dataCode: string;
    deCode: string;
    remark: string;
  }) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: "/data/data/remark",
      data: params,
    });
  //更新表单状态
  updateFormState = (params: { action: string; formId: string }) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: "/data/form/state",
      data: params,
    });
  //获取质疑类型
  getQuestionTypes = () =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: "/data/question/types",
    });
  //添加质疑
  addQuestion = (params: {
    formId: string;
    content: string;
    dataCode: string;
    deCode: string;
    formActions: string;
    sendTo?: string;
    type: string;
  }) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: "/data/question",
      data: params,
    });
  //回复质疑
  answerQuestion = (params: {
    formId: string;
    content: string;
    dataCode: string;
    deCode: string;
    questionId: string;
    type: string;
    value?: string;
  }) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: "/data/question/answer",
      data: params,
    });
  //关闭质疑
  closeQuestion = (params: {
    dataCode: string;
    deCode: string;
    formId: string;
    questionId: string;
  }) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: "/data/question/close",
      data: params,
    });
  //重新打开质疑
  reopenQuestion = (params: {
    dataCode: string;
    deCode: string;
    formId: string;
    questionId: string;
  }) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: "/data/question/reopen",
      data: params,
    });
  //修改实际访视日期
  modifyVisitDate = (params: { visitDate: string; visitId: string }) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: "/data/visit/date",
      data: params,
    });
  // 修改计划
  modifyPlanDate = (params: {
    planDate: string;
    visitId: any;
    subjectCode: any;
    changeOtherVisitDate: any;
  }) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: "/data/visit/planDate",
      data: params,
    });

  //修改实际访视日期
  modifyAppointmentDate = (params: {
    appointmentDate: string;
    visitId: string;
  }) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: "/data/visit/appointment",
      data: params,
    });
  //获取受试者备注type
  getRemarkType = (params: { type: string }) =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/config/dictionaries/getTypeByCode/${params.type}`,
    });
  //添加受试者备注
  addRemark = (params: {
    subjectCode: string;
    isWarning: number;
    remark: string;
    remarkType: string;
  }) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: `/data/subject/addRemark`,
      data: params,
    });
  //数据稽查
  getTrance = (params: { formId: string; dataCode: string }) =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/data/form/${params.formId}/data/${params.dataCode}/trace`,
    });
  // 获取type列表
  getTypeList = () =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: "data/task/type",
    });
  //更新ocr上传图片集合
  updateOcrList = (params: { formId: string; images: Array<any> }) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: `/data/ocr/update`,
      data: params,
    });
  // 是否支持脱敏
  isDesensitizateProject = (params: { projectCode: string }) =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `file/image/isDesensitizateProject?projectCode=${params.projectCode}`,
      data: params,
    });
  // OCR敏感信息 记录
  GetOcrSensitiveRecord = (params: { imgUrl: Array<String> }) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: "ocr/sensitive/record",
      data: params,
    });
  // 划词排序
  getDataOcrSort = (params: { imgUrl: Array<String> }) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: "/ocr/automatic/record",
      data: params,
    });
  // 获取角标
  getOcrPositionSort = (params: { imgUrl: Array<String> }) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      // url: '/ocr/get/ocrField', // dct服务，此处不能使用
      url: "/ocr/get/ocrField/data",
      data: params,
    });
  // 删除图片
  DeleteImageData = (params: {
    formId: string;
    dataCode: string;
    deCode: string;
    value: any;
    dataTenantCode: any;
  }) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: "/data/data/image/delete",
      data: params,
    });
  // 菜单显示
  GetConfigMenu = (params: { userId: string }) =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: "/channel/config/menu",
      params: params,
    });
  // 发现列表
  GetConfigFind = (params: { userId: string }) =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: "/channel/config/find",
      params: params,
    });
  // 查看详情、立即进入
  GetConfigDetail = (params: { appCode: any; userId: any }) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: "/channel/config/detail",
      data: params,
    });

  // 获取图片验证码
  GetImageCode = (params: { phone: string }) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: "/plat/doctorStudio/phone/imageCode",
      data: params,
    });

  // 获取短信验证码
  GetVerificationCode = (params: {
    appCode: any;
    imageCode: any;
    phone: string;
  }) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: "/plat/doctorStudio/phone/verificationCode",
      data: params,
    });
  // 查询医患端账号信息
  GetDoctorStudioInfo = (params: {
    account?: any;
    accountType?: any;
    appCode?: any;
    password?: any;
    verificationCode?: string;
  }) =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: "/plat/doctorStudio/user/info",
      params: params,
    });
  // 查询EDC账号医生信息
  GetAccountInfo = () =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: "/plat/account/accountInfo",
      // params: params
    });

  // 中台账号注册并绑定
  MiddleAccountBind = (
    params: [
      {
        username?: any;
        appCode: any;
        appUserId: any;
        password?: any;
        phone?: any;
      }
    ]
  ) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: "/plat/middle/account/bind",
      data: params,
    });

  // 补充医患端账号信息
  GetUserCompletion = (params: {
    account: any;
    accountType: any;
    appCode: any;
    department?: any;
    hospital?: any;
    name: any;
    title?: any;
  }) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: "/plat/doctorStudio/user/completion",
      data: params,
    });

  // 病种选择
  GetDiseaseList = (params: { userId: string }) =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: "/channel/bindingRecord/disease/entities/list",
      params: params,
    });

  // 病种关注
  GetDiseaseFollow = (params: {
    account?: any;
    accountType?: any;
    department?: any;
    diseases?: any;
    hospital?: any;
    name?: any;
    tenantCode?: any;
    title?: any;
  }) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: "/channel/bindingRecord/disease/entities/follow",
      data: params,
    });

  // 授权信息
  GetAppAuthorize = (params: {
    appCode?: any;
    list?: any;
    otherTenantCode?: any;
  }) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: "/channel/appAuthorize/save",
      data: params,
    });

  // 租户小程序
  GetAppTenantConfig = (params: { appCode?: any }) =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: "/channel/appTenantConfig/getData",
      params: params,
    });

  // 获取OSS访问令牌
  GetCaseSts = () =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: "/file/sts/getStsToken",
    });

  /**
   * 拒绝原因信息
   */
  GetAuditRejectReasons = (params: { subjectCode: string }) =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: "/data/subject/audit/info",
      params: params,
    });

  /*
   * 受试者首页审核评论
   */
  submitCommentSave = (params: {
    content: String;
    subjectCode: String;
    id?: any;
  }) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: "/data/subject/comment/save",
      data: params,
    });
  /*
   * 受试者首页审核评论查看
   */
  GetSubjectComments = (code: String) =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: "/data/subject/comments/" + code,
    });
  /*
   * 受试者详情（包含表单详情）
   */
  GetSubjectDetail = (code: String) =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: "/data/subject/detail/" + code,
    });
  /*
   * 查询用户在当前项目下的角色
   */
  GetUserProjectRoles = (params: { projectCode: String; userCode: String }) =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/project/api/project/${params.projectCode}/user/${params.userCode}/roles`,
    });
  /**
   * 查询医生工作室首页菜单
   */
  GetMenus = (params: { type: String }) =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/plat/menus`,
      params: params,
    });
  /**
   * 获取服务协议列表
   */
  GetLaborAgreementList = (params: { projectCode?: any; status?: any }) =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: "/balance/laborAgreement/user/laborAgreementList",
      params: params,
    });
  /**
   * 获取服务协议列表_新
   */
  GetLaborUserAgreementList = (params: {
    projectCode?: any;
    status?: any;
    index?: number;
    page?: number;
    pageSize?: number;
  }) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: "/plat/user/agreement/list",
      data: params,
    });
  /**
   * 服务协议详情
   */
  GetLaborAgreementDetail = (id: string) =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/balance/laborAgreement/detail/${id}`,
    });
  /**
   * 服务协议详情_新
   */
  GetLaborUserAgreementDetail = (code: string) =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/plat/user/agreement/detail/${code}`,
    });
  /**
   * 根据旧协议重新生成协议
   */
  toGenerateAfreshSignLaborUserAgreement = (code: string) =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/plat/user/agreement/afresh/generate/${code}`,
    });
  /**
   * 服务协议生成签名
   */
  toSignLaborAgreement = (params: {
    agreementId: number;
    sign: string;
    signImg: string;
  }) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: "/balance/laborAgreement/sign",
      data: params,
    });
  /**
   * 服务协议生成签名
   */
  toSignLaborUserAgreement = (params: {
    code?: string;
    codes?: Array<string>;
    sign: string;
  }) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: "/plat/user/agreement/sign",
      data: params,
    });
  /**
   * 服务协议生成签名批量
   */
  toSignLaborUserBatchAgreement = (params: {
    code?: string;
    codes?: Array<string>;
    sign: string;
  }) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: "/plat/user/agreement/batch/sign",
      data: params,
    });
  /**
   * 是否有新的服务协议
   */
  GetAgreementViewCount = () =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: "/plat/user/agreement/view/count",
    });
  /**
   * 获取收款信息
   */
  GetCollectionInfo = () =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: "/plat/user/collection/get",
    });
  /**
   * 更新个人收款信息
   */
  UpdateCollectionInfo = (params: {
    account?: string;
    bankNumber?: string;
    bankOfDeposit?: string;
    userCode?: string;
  }) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: "/plat/user/collection/save",
      data: params,
    });
  /**
   * 获取个人信息
   */
  GetPersonalInfo = () =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: "/plat/user/personal/get",
    });
  /**
   * 更新个人信息
   */
  UpdatePersonalInfo = (params: {
    birthTime?: string;
    city?: string;
    dept?: string;
    hospital?: string;
    idCard?: string;
    jobTitle?: string;
    name?: string;
    province?: string;
    userCode?: string;
  }) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: "/plat/user/personal/save",
      data: params,
    });
  // 获取图形验证码
  GetGraphCode = (params: { uuid: any }) =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/plat/apply/captcha.jpg?uuid=${params.uuid}`,
      data: params,
    });

  //获取短信验证码
  GetSmsCode = (params: { phone: any; imgUUId: any; imgCode: any }) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: `/plat/apply/sms/sendCode`,
      data: params,
    });

  //重置密码获取短信验证码
  GetResetPwdSmsCode = (params: { phone: any; imgUUId: any; imgCode: any }) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: `/plat/user/sms/sendCode`,
      data: params,
    });

  // 验证手机号
  GetPhoneValidate = (params: {
    phone: any;
    phoneCode: any;
    activityCode?: any;
  }) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: `/plat/apply/sms/check`,
      data: params,
    });

  // 验证手机号
  ToResetPhoneValidate = (params: { phone: any; phoneCode: any }) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: `/plat/user/sms/check/generate_refresh_pass_code`,
      data: params,
    });

  // 验证手机号
  ToResetNewPassword = (params: {
    newPass: string;
    resetType: string;
    refreshCode: string;
  }) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: `/plat/user/pass/change`,
      data: params,
    });

  // 发送验证码
  SendCode =  (params: { phone: any; }) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: `/plat/user/sms/sendCode1`,
      data: params,
    });

  // 验证密码
  GetPassWordRegister = (params: {
    name?: any;
    phone?: any;
    hospitalName?: any;
    jobTitle?: any;
    dept?: any;
    idCard?: any;
    bankNumber?: any;
    bankOfDeposit?: any;
    userName?: any;
    passWord?: any;
    phoneCode?: any;
    imgCode?: any;
    city?: any;
    needAuth?: any;
    certificateUrl?: any;
    doctorName?: any;
    activityCode?: any;
    projectCodes?: any;
  }) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: `/plat/apply/register`,
      data: params,
    });

  // 修改（完善信息）
  UpdateApply = (params: {
    name?: any;
    phone?: any;
    hospitalName?: any;
    jobTitle?: any;
    dept?: any;
    idCard?: any;
    bankNumber?: any;
    bankOfDeposit?: any;
    userName?: any;
    passWord?: any;
    phoneCode?: any;
    imgCode?: any;
    city?: any;
    needAuth?: any;
    certificateUrl?: any;
    doctorName?: any;
    id?: any;
    activityCode?: any;
  }) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: "/plat/apply/update",
      data: params,
    });
  /**
   * 服务协议阅读协议
   */
  toUserAgreementRead = (params: { code: string }) =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: "/plat/user/agreement/read",
      params: params,
    });
  /**
   * 服务协议批量阅读
   */
  toUserAgreementMultiRead = (params: { codes: Array<string>[] }) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: "/plat/user/agreement/batch/read",
      data: params,
    });
  /**
   * 结算单阅读协议
   */
  toUserSettlementRead = (params: { id: string }) =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: "/balance/user/settlement/read",
      params: params,
    });
  /**
   * 结算单阅读协议待阅读数量
   */
  GetUserSettlementViewCount = () =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: "/balance/user/settlement/view/count",
    });
  /**
   * 结算单详情
   */
  getPaySheetList = (params: {
    startTime: string;
    endTime: string;
    projectCode?: string;
    page?: number;
    pageSize?: number;
  }) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: `/balance/user/settlement/page`,
      data: params,
    });
  /**
   * 结算单详情
   */
  getPaySheetDetail = (id: number) =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/balance//user/settlement/detail/${id}`,
    });
  /**
   * 审核失败重新提交审核
   */
  toAuditResubmit = (code: string) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: `/data/subject/audit/resubmit/${code}`,
    });
  /**
   * 获取优秀案例列表
   */
  getSolicitationPage = (params: {
    projectCodes?: Array<string>;
    tenantCode?: string;
    projectCode?: string;
    title?: string;
    label?: string;
    page: number;
    pageSize: number;
  }) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: `/project/solicitation/page`,
      data: params,
    });
  /**
   * 获取优秀案例类型标签列表
   */
  getLabelList = (params: {
    projectCodes: Array<[]>;
    tenantCodes: Array<[]>;
  }) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: `/project/label/list`,
      data: params,
    });

  /**
   * （医脉通项目）获取报名活动
   */
  getProjectActivity = (params: { activityCode: string }) =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/plat/platProjectRegister/getProjectActivity`,
      params: params,
    });

  /**
   * （医脉通项目）生成小程序url scheme
   */
  getAppSecretScheme = (params: {
    appCode?: any;
    envVersion?: any;
    path?: any;
    query?: any;
  }) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: `/channel/appSecret/generate/scheme`,
      data: params,
    });
  /**
   * 查看优秀案例详情
   */
  getSolicitationDetail = (id: number) =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/project/solicitation/detail/${id}`,
    });

  /**
   * 查看优秀案例详情的评论列表
   */
  getSolicitationRemark = (params: { id: any }) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: `/project/solicitation/remark/page`,
      data: params,
    });

  /**
   * 查看优秀案例详情的发表评论
   */
  createSolicitationRemark = (params: {
    content: "";
    nickName: "";
    profileImg: "";
    solicitationId: "";
  }) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: `/project/solicitation/remark/create`,
      data: params,
    });

  /**
   * 查看微信个人信息
   */
  getUserInfoByOfficialAccount = (params: any) =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/channel/officialAccount/getUserInfo`,
      params: params,
    });

  /**
   * 相同大小视频处理
   */
  getDealSameVideo = (params: {
    projectCode: any;
    subjectCode: any;
    videoName: any;
    videoSize: any;
  }) =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/file/video/dealSameVideo`,
      params: params,
    });
  /**
   * 租户首页
   */
  getDoctorHomePage = (tenantCode: string) =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/plat/tenant/main?tenantCode=${tenantCode}`,
    });
  /**
   * 租户首页配置
   */
  getDoctorHomeData = (data: { tenantCode: string; types: Array<string> }) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: `/plat/tenant/main/datas`,
      data: data,
    });
  /**
   * 量表工具，工具介绍导航分类
   */
  getScaleIntroduceData = (data: {
    categoryCode?: string;
    index?: number;
    page?: number;
    pageSize?: number;
    title?: string;
  }) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: `/plat/p_scale/introduce/page`,
      data: data,
    });
  /**
   * 量表工具，量表介绍详情
   */
  getScaleIntroduceDetail = (data: { scaleCode?: string }) =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/plat/p_scale/introduce/detail/${data.scaleCode}`,
    });
  /**
   * 获取当前协作组信息
   */
  getCollaborativeInfo = (params: { collaborativeCode?: any }) =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/project/collaborative/index/${params.collaborativeCode}`,
      data: params,
    });
  /**
   * 获取量表工具列表
   */
  getScalePage = (params: any) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: `/plat/p_scale/home/page`,
      data: params,
    });
  /**
   * 获取量表工具列表新
   */
  getNewScalePage = (params: any) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: `/plat/p_scale/home/page/none/common`,
      data: params,
    });
  /**
   * 获取指南数据
   */
  getHandBookList = (params: any) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: `/plat/handBook/list`,
      params: params,
    });
  /**
   * 获取预签署状态
   */
  getPreSignStatus = (params: { projectCode: any }) =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/project/pre/sign/status`,
      params: params,
    });
  /**
   * 保存首页工具
   */
  saveScale = (params: any) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: `/plat/p_scale/user/save`,
      data: params,
    });

  /**
   * 获取病种标签列表
   */
  getDiseaseLabels = (params: any) =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/plat/tenant/disease/labels`,
      params: params,
    });

  /**
   * 保存表单数据(crf)
   */
  saveCrfForm = (params: { formId: any; submit: any; values: Array<any> }) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: `/data/crfData`,
      data: params,
    });

  /**
   * 数据修改(cfr)
   */
  updateCrfData = (params: {
    formId: string;
    dataCode: string;
    deCode: string;
    value: any;
  }) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: "/data/data/crfUpdate",
      data: params,
    });

  /**
   * edc-查看服务协议
   */
  getSubjectAgreement = (params: { subjectCode: any }) =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/data/subjectAgreement/getAgreement`,
      params: params,
    });

  /**
   * edc-立即签名
   */
  subjectSign = (params: { sign: string; subjectCode: string }) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: `/data/subjectAgreement/sign`,
      data: params,
    });

  /**
   * edc-重新签名
   */
  subjectReSign = (params: { sign: string; subjectCode: string }) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: `/data/subjectAgreement/reSign`,
      data: params,
    });

  /*
   * 个人可用分组列表
   */
  getGroupSelfList = () =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/visit/group/self/list`,
    });

  /**
   * 病历状态枚举
   */
  getCaseStateEnums = () =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/visit/case/state/enums`,
    });

  /**
   * 病历分页
   */
  getCasePage = (params: any) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: `/visit/case/page`,
      data: params,
    });

  /*
   * 病历详情
   */
  getCaseDetail = (code: string) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: `/visit/case/detail/${code}`,
    });

  /*
   * 转档信息
   */
  getCaseTransferFileInfo = (param: { caseCode: string }) =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/visit/case/transfer/file/info`,
      params: param,
    });

  /*
   * 转档登记
   */
  toCaseTransferFileRegister = (param: { caseCode: string }) =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/visit/case/transfer/file/register`,
      params: param,
    });

  /**
   * 个人可用分组选择项数据
   */
  getGroupSelfSelect = () =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/visit/group/self/select`,
    });

  /**
   * 分组方案节点选择
   */
  getGroupVisitNodeSelect = (params: { groupCode: string }) =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/visit/group/visit/node/select`,
      params,
    });

  /**
   * 患者预创建
   */
  preCreatePatient = (params: any) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: `/visit/patient/pre/create`,
      data: params,
    });

  /**
   * 事件完成
   */
  finishTask = (params: any) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: `/visit/case/task/finish`,
      data: params,
    });

  /**
   * 更新患者信息 (建档时可用)
   */
  updatePatientInfo = (params: { caseCode: string; formDatas: any }) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: `/visit/case/update/patient/info`,
      data: params,
    });

  /**
   * 建档信息
   */
  getCaseFileInfo = (params: any, headers: object) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: `/visit/case/file/info`,
      data: params,
      headers: headers as AxiosRequestHeaders,
    });

  /**
   * 患者知情同意书详情
   */
  getPatientInformedConsent = (params: any, headers: object) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: `/visit/patient/informed/consent/detail`,
      data: params,
      headers: headers as AxiosRequestHeaders,
    });

  // 获取小程序短链接
  apiAppSecretGenerateUrl = (params: {
    appCode: string;
    envVersion: string;
    path: string;
    query: string; // 注意，携带中文会不返回data
  }) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: `/channel/appSecret/getGenerateUrl`,
      params: params,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8", // 注意、必须
      },
    });

  /**
   * 获取患者病历
   */
  getPatientCaseInfo = () =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/visit/patient/case/info`,
    });

  /**
   * 获取患者今日任务
   */
  getPatientTaskListToday = () =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: `/visit/task/list/today`,
    });

  /**
   * 获取患者明日计划
   */
  getPatientTaskListTomorrow = () =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: `/visit/task/list/tomorrow`,
    });

  /**
   * 获取患者已完成任务
   */
  getPatientTaskListComplete = () =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: `/visit/task/list/yesterday`,
    });

  /**
   * 医助类型
   */
  getVisitAssistantRoleList = () =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/visit/assistant/role/list`,
    });

  /**
   * 获取医生用户信息
   */
  getDoctorInfo = () =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/visit/doctor/info`,
    });

  /**
   * 获取医助用户信息
   */
  getAssistantInfo = () =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/visit/assistant/info`,
    });

  /**
   * 医助完善信息
   */
  toAssistantPerfectInfo = (params: any) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: `/visit/assistant/perfect/info`,
      data: params,
    });

  /**
   * 医生完善信息
   */
  toDoctorPerfectInfo = (params: any) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: `/visit/doctor/perfect/info`,
      data: params,
    });
  /**
   * 获取分组健康提醒
   */
  getGroupHealthTip = (params: any) =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/visit/group/health/tip`,
      params: params,
    });

  /**
   * 获取分组健康提醒
   */
  getDoctorTeamAssistants = () =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/visit/team/assistants`,
    });

  /**
   * 医助-我的医生
   */
  getTeamDoctors = (params?: any) =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/visit/team/doctors`,
      params: params,
    });

  /**
   * 医助-所有医生
   */
  getTeamAllDoctors = () =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/visit/team/allDoctors`,
    });

  /**
   * 医助-搜索我的医生
   */
  getTeamDoctorsSearch = (params: any) =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/visit/team/doctor/search`,
      params: params,
    });

  /**
   * 医助分组选择项
   */
  getAssistantGroupSelect = () =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/visit/assistant/group/select`,
    });

  /**
   * 绑定申请
   */
  submitTeamBindDoctor = (params: any) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: `/visit/team/bind/doctor`,
      data: params,
    });
  /**
   * 医生的医助申请列表
   */
  doctorApplyList = (type: any) =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/visit/team/assistant/apply/list/${type}`,
    });
  /**
   * 医生的医助申请详情
   */
  doctorApplyListDetail = (id: any) =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/visit/team/assistant/apply/detail/${id}`,
    });
  /**
   * 医生的医助申请处理
   */
  doctorAssistantApplyListHandle = (params: any) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: `/visit/team/assistant/apply/handle`,
      data: params,
    });
  /**
   * 医生的医助申请数
   */
  getVisitTeamAssistantApplyCount = () =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/visit/team/assistant/apply/count`,
    });
  /**
   * 添加报名信息
   */
  toVisitRegisterAdd = (params: {
    assistantType?: any;
    certificate?: any;
    city?: any;
    dept?: any;
    groupCode?: any;
    name?: any;
    province?: any;
    sex?: any;
    userCode?: any;
  }) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: `/visit/register/add`,
      data: params,
    });
  /**
   * 获取报名信息
   */
  getRegisterCompletedInfo = (params: { groupCode: string }) =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/visit/register/get`,
      params,
    });
  /**
   * 根据code获取医助详情
   */
  getAssistantDetail = (assistanCode: string) =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/visit/assistant/detail/${assistanCode}`,
    });
  /**
   * 协管分组
   */
  getGroupAssist = (params: { assistantCode?: any; doctorCode?: any }) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: `/visit/group/assist`,
      data: params,
    });

  // AE ↓
  /**
   * [问卷] 标签列表
   */
  getQaTags = () =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/knowledge/qa/tags`,
    });

  /**
   * [问卷] 问答搜索
   */
  getQaSearch = (params: { content?: string; tenantCode?: string }) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: `/knowledge/qa/search`,
      data: params,
    });

  /**
   * [问卷] 随机问答列表
   */
  getQaRandom = () =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/knowledge/qa/random`,
    });

  /**
   * 签到首页
   */
  getSignInHome = () =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/knowledge/signIn/home`,
    });

  /**
   * 记录签到
   */
  toSignInRecord = () =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/knowledge/signIn/record`,
    });

  /**
   * 签到日历
   */
  getSignInCalendar = (params: { year?: any; month?: any }) =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/knowledge/signIn/calendar/${params.year}/${params.month}`,
    });

  /**
   * 获取个人信息
   */
  getAePersonalInfo = () =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/plat/user/personal/get`,
    });

  /**
   * 获取身体所有部位code
   */
  getDiagnosisPosition = () =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/knowledge/diagnosis/config/position`,
    });

  /**
   * 获取身体部位症状
   */
  getDiagnosisSymptom = (code: string) =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/knowledge/diagnosis/config/symptom/${code}`,
    });

  /**
   * 获取AE所有药品
   */
  getDiagnosisDrugs = (code: string) =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/knowledge/diagnosis/config/drugs`,
    });

  /**
   * AE上报
   */
  addAeReport = (params: any) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: `/knowledge/aeReport/add`,
      data: params,
    });

  /**
   * 任务列表
   */
  getAeTaskList = (params: any) =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/knowledge/task/list`,
      params: params,
    });

  /**
   * 领取奖励
   */
  toGetAeTaskClaim = (params: any) =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/knowledge/task/claim`,
      params: params,
    });

  /**
   * 积分总数
   */
  toGetAeAllCount = () =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: `/knowledge/integral/count`,
    });

  /**
   * 获取AE自测工具量表type
   */
  getQuestionnaireType = () =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/knowledge/questionnaire/list/type`,
    });

  /**
   * 根据type获取AE自测工具量表
   */
  getQuestionnaireList = (type: any) =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/knowledge/questionnaire/list/${type}`,
    });
  /**
   * 积分记录列表
   */
  getAePointRecords = (params: {
    type?: "add" | "del";
    page?: any;
    pageSize?: any;
  }) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: `/knowledge/integral/records`,
      data: params,
    });
  /**
   * 问卷list
   */
  getAeQuestionnaireList = (tagCode: any) =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/knowledge/questionnaire/list/${tagCode}`,
    });
  /**
   * 问卷listType
   */
  getQuestionnaireTag = () =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/knowledge/questionnaire/tag`,
    });
  /**
   * 问卷列表
   */
  getQuestionnaireConfig = () =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/knowledge/questionnaire/config`,
    });
  /**
   * 问卷标签配置
   */
  getQuestionnaireLists = (params: { symptomCode?: any }) =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/knowledge/questionnaire/list`,
      params: params,
    });
  /**
   * alk标签配置
   */
  getQuestionnaireAlkConfig = () =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/knowledge/questionnaire/config/alk`,
    });
  /**
   * alk标签配置列表
   */
  getQuestionnaireAlkList = (params: { symptomCode?: any }) =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/knowledge/questionnaire/list/alk`,
      params: params,
    });
  /**
   * 根据量表code获取量表配置信息
   */
  getEvaluationInfo = (params: any) =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/knowledge/questionnaire/detail/${params.scaleCode}`,
    });

  /**
   * 报告配置
   */
  getEvaluationConfig = () =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/knowledge/evaluation/config`,
    });
  /**
   * 保存报告
   */
  toSaveEvaluation = (params: any) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: `/knowledge/evaluation/save`,
      data: params,
    });
  /**
   * 报告详情
   */
  getEvaluationDetail = (code: any) =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/knowledge/evaluation/detail/${code}`,
    });
  /**
   * 报告详情
   */
  getEvaluationPage = (params: any) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: `/knowledge/evaluation/page`,
      data: params,
    });
  /**
   * 记录保存
   */
  toQuestionnaireRecordSave = (params: any) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: `/knowledge/questionnaire/record/save`,
      data: params,
    });
  /**
   * 记录详情
   */
  getQuestionnaireRecordDetail = (params: any) =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/knowledge/questionnaire/record/detail`,
      params: params,
    });
  /**
   * 记录统计
   */
  getQuestionnaireRecordStatistics = (params: any) =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/knowledge/questionnaire/record/statistics`,
      params: params,
    });
  /**
   * 记录统计
   */
  getQuestionnaireRecordList = (params: any) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: `/knowledge/questionnaire/record/list`,
      data: params,
    });
  /**
   * 配置数据
   */
  getQuestionConfig = () =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/knowledge/question/config`,
    });
  /**
   * 详情
   */
  getQuestionDetail = (params: { questionId: string }) =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/knowledge/question/detail`,
      params: params,
    });
  /**
   * 列表
   */
  getQuestionList = (params: any) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: `/knowledge/question/list`,
      data: params,
    });
  // 评测结果页
  getListReport = (params: any) =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/knowledge/questionnaire/list/report`,
      params: params,
    });
  // 报告推荐列表
  getQuestionListReport = (params: { reportCode: string }) =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/knowledge/question/list/report`,
      params: params,
    });

  // 获取健康提醒列表
  getAeRemindList = (params?: any) =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/knowledge/health/remind/list/running`,
      params: params,
    });

  // 健康提醒状态设置
  setHealthState = (params: any) =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/knowledge/health/remind/state/setting`,
      params: params,
    });
  // 用药、就诊保存
  setCalendarRemindSave = (params: any) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: `/knowledge/health/remind/save`,
      data: params,
    });
  // 用药提醒刪除
  setCalendarRemindDelete = (params: any) =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/knowledge/health/remind/delete`,
      params: params,
    });
  // 用药提醒配置
  getMedicineFrequencyConfig = () =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/knowledge/health/remind/medication/config`,
    });
  // 状态设置
  setHealthRemindStateSetting = (params: any) =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/knowledge/health/remind/state/setting`,
      params: params,
    });
  // 提醒列表
  getHealthRemindList = () =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/knowledge/health/remind/list`,
    });
  //获取展示模板
  getHealthDisplayGet = (params: { displayCode: string; version: string }) =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/design/display/get`,
      params: params,
    });
  // 自测工具推荐列表
  getListQuestionnaire = (params: { recordId: string }) =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/knowledge/question/list/questionnaire`,
      params: params,
    });
  // 提问功能
  submitIssueAsk = (params: any) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: `/knowledge/issue/ask`,
      data: params,
    });
  //问卷类型枚举
  getQuestionnaireTypeEnums = (params: any) =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/knowledge/questionnaire/type/enums`,
      params: params,
    });
  // AE ↑
  // CSO ↓
  // 获取医生信息
  getCsoDoctorInfo = (params?: any) =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/visit/doctor/info`,
      params: params,
    });
  // 获取患者信息
  getCsoDoctorPatientsInfo = (params?: any) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: `/visit/doctor/my/patients`,
      data: params,
      // method: 'post',
      // url: `/order/record/page/for/patient`,
      // data: params
    });
  // 获取患者信息
  getCsoHomeModule = (params: { mainCode: string; version: string }) =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/design/main/get`,
      params: params,
    });
  // 获取列表
  getPlanList = (params: any) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: `/visit/treatment/plan/list`,
      data: params,
    });
  // 个人处方列表页分页
  getPlanSelfList = (params: any) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: `/visit/treatment/plan/self/list/page`,
      data: params,
    });
  // 收藏
  getPlanCollect = (params: any) =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/visit/treatment/plan/collect`,
      params: params,
    });
  // 获取搜索列表
  getPlanPage = (params: any) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: `/visit/treatment/plan/page`,
      data: params,
    });
  // 获取详情
  getPlanDetail = (params: { code: string; enableSearch?: boolean }) =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/visit/treatment/plan/detail/${params.code}${
        params.enableSearch != undefined
          ? `?enableSearch=${params.enableSearch}`
          : ""
      }`,
    });
  // 获取推荐详情
  getPlanRecommendDetail = (params: { code: string }) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: `/visit/treatment/plan/common/${params.code}`,
    });
  // 生成海报
  generateTreatmentPlanPoster = (params: {
    treatmentPlanCode: string;
    url: string;
  }) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: `/visit/treatment/plan/generate/poster`,
      data: params,
    });
  // 生成流程
  getDoctorFlowGenerate = (params: any) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: `/visit/doctor/flow/generate`,
      data: params,
    });
  // 生成流程
  getDoctorRecordStatistics = (params: { projectCode: string }) =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/visit/doctor/record/statistics`,
      data: params,
    });
  // 获取医生下的患者
  getDoctorsPatientsDetail = (params: { patientCode: string }) =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/visit/doctor/patients/detail`,
      params: params,
    });
  // 获取医生下患者的记录
  getDoctorsPatientRecordList = (params: {
    projectCode: string;
    patientCode: string;
    page: number;
    pageSize: number;
    state?: number;
  }) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: `/order/record/list/doctor`,
      data: params,
    });
  // 注册供应商
  getSupplierRegister = (params: {
    projectCode: string;
    invitationId: string;
  }) =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/cso/supplier/register`,
      params: params,
    });
  // 供应商的项目列表
  getProjectSupplierList = (params: any) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: `/cso/project/list/supplier`,
      data: params,
    });
  // 处方类型枚举
  getTreatmentPlanTypeEnums = () =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/visit/treatment/plan/type/enums`,
    });
  // 治疗列表
  getTreatmentPlanList = (params: any) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: `/visit/treatment/plan/list`,
      data: params,
    });
  // 治疗列表
  getTreatmentPlanListPage = (params: any) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: `/visit/treatment/plan/list/page`,
      data: params,
    });
  // 查询属性名称和编号
  getPropertiesList = (type: any) =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/visit/properties/list/${type}`,
    });
  // 获取治疗列表详情
  getTreatmentPlanDetail = (treatmentPlanCode: any, enableSearch?: boolean) =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/visit/treatment/plan/detail/${treatmentPlanCode}${
        enableSearch != undefined ? `?enableSearch=${enableSearch}` : ""
      }`,
    });
  // CSO ↑

  // 结算申请项目列表
  getSettlementProjects = () =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/project/settlement/user/projects`,
    });

  // 新建申请可选受试者列表
  getSettlementSubjectList = (params: {
    projectCode: string;
    endDate?: string;
    startDate?: string;
  }) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: `/data/settlement/subjectList`,
      data: params,
    });

  // 结算申请立即申请
  approveSettlement = (params: { projectCode: string; subjectCodeList: [] }) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: `/data/settlement/approve`,
      data: params,
    });

  // 结算申请记录
  getSettlementApproveRecord = (params: { page: number; pageSize: number }) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: `/data/settlement/approveRecord`,
      data: params,
    });

  // 结算申请记录详情
  getApproveSettlementDetail = (params: { approveRecordId: string }) =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/data/settlement/approveRecordDetail`,
      params: params,
    });

  // 获取可结算余量
  getSettlementBalance = (params: { projectCode: string }) =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/data/settlement/settlementBalance`,
      params: params,
    });

  // 获取可修改余量
  getSettlementUpdateBalance = (params: { approveRecordId: string }) =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/data/settlement/settlementUpdateBalance`,
      params: params,
    });

  //申请单修改
  updateSettlementBalance = (params: {
    approveRecordId: string;
    num: number;
  }) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: `/data/settlement/update`,
      data: params,
    });

  //结算申请撤销
  rollbackSettlement = (params: { approveRecordId: string }) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: `/data/settlement/rollback/${params.approveRecordId}`,
    });
  /**
   * 保存纽迪希亚表单数据(crf)
   */
  saveNudisiaCrfForm = (params: any) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: `/visit/patient/v2/save`,
      data: params,
    });

  //签名回传
  singleAudit = (params: { signUrls: any; subjectCode: any }) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: `/data/singleAudit/sign`,
      data: params,
    });

  //重新签名回传
  reSingleAudit = (params: { signUrls: any; subjectCode: any }) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: `/data/singleAudit/reSign`,
      data: params,
    });

  //获取病例签名
  getSingleSign = (params: { subjectCode: any }) =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/data/singleAudit/getSign`,
      params: params,
    });

  //生成病例预览
  createCaseImage = (params: { htmlText: any; subjectCode: any }) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: `/data/singleAudit/createCaseImage`,
      data: params,
    });

  //是否有待单病例签名
  checkSingleSign = () =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/data/task/checkSingleSign`,
    });

  //发送病例邮件
  sendCaseEmail = (params: { email: any; subjectCode?: any }) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: `/data/singleAudit/sendCaseEmail`,
      data: params,
    });

  //是否有待单病例签名
  getCaseEmail = () =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/data/singleAudit/getCaseEmail`,
    });
  //活动参与查询
  queryActivity = (params: { type: string }) =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/cso/activity/participation/query`,
      params: params,
    });
  //行为记录查询
  actionRecordQuery = (params: { type: string }) =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/cso/action/record/query`,
      params: params,
    });
  //行为记录保存
  actionRecordSave = (params: { type: string }) =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/cso/action/record/save`,
      params: params,
    });
  // 项目供应商
  getProjectSupplier = (params: { doctorCode: string; tenantCode: string }) =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/cso/project/api/supplier`,
      params: params,
    });

  // 获取医生编码
  getYsbmApi = (id: string) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: `/project/user/getYsbm?projectId=${id}`,
    });
  getReportRecodProject = (params: {}) =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: "/data/report/subject/projects",
      params: params,
    });
  getSubjectList = (params: { projectCode: string }) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: `/data/report/subject/project`,
      params: params,
    });
  getSubjectBindingInfo = (params: { subjectCode: string }) =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/data/report/subject/binding/info2/${params.subjectCode}`,
    });
  sujectBinded = (params: {
    doctorName: string;
    reportName: string;
    reportUser: string;
    subjectCode: string;
    doctorCode: string;
    randomCode: string;
    projectCode: string;
    txr: string,
    xb: string,
    xs: string,
    jycb: string,
    jzcs: string
  }) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: `/data/report/subject/binded`,
      data: params,
    });
  saveReportScale = (params: {
    subjectCode: string;
    scaleId: number;
    scaleServerRecordId: number;
  }) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: `/data/report/record/save`,
      data: params,
    });
  getScaleRecord = (params: { scaleId: number }) =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/data/report/subject/scale/record?scaleId=${params.scaleId}`,
    });
  getScaleRecordCount = (params: { scaleIds: string }) =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/data/report/record/count?scaleIds=${params.scaleIds}`,
    });

  // 根据量表code和受试者编码，获取随访list
  getVisitsByScaleCode = ({ scaleCode, subjectCode }: any) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: `/data/report/subject/scale/visit?scaleCode=${scaleCode}&subjectCode=${subjectCode}`,
    });
  // 标记量表已查看
  updateReadStatus = (scaleId: number, subjectCode: string) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: `data/report/View/scale/${scaleId}?subjectCode=${subjectCode}`,
    });
  // 患者上传记录查询
  getReportedById = (params: any) =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/data/report/record/findByCodeAndVisitId`,
      params,
    });
  // 患者上传记录查询
  getSubjectBindState = (subjectCode: string) =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/data/report/subject/binding/info/${subjectCode}`,
    });
  // 患者触发绑定前置动作
  getSubjectBinding = (data: any) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: `/data/report/subject/scancode/binding`,
      data,
    });
  // 患者解绑
  subjectUnbind = (subjectCode: string) =>
    createAxiosHttp<IResult<any>>({
      method: "get",
      url: `/data/report/subject/unbind`,
      params: { subjectCode },
    });

  // 获取解绑记录
  getUnbindRecord = <T>(subjectCode: string)=> createAxiosHttp<IResult<T>>({
    url: 'data/report/unbind/record',
    params: {
      subjectCode
    }
  })

  // 自报提醒
  remindBySms = (data: any) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: `/data/report/remind/sms`,
      data,
    });
  // 重报提醒
  restatement = (data: any) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: `/data/report/record/restatement`,
      data,
    });

  // 扫码填写问卷
  scanExamCode = (data: any) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: `/data/report/scanCode/url`,
      data,
    });
  // 获取统计数据
  getStats = (params: { projectCode?: any }) =>
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: `/data/subject/center/stats2?projectCode=${
        params.projectCode || ""
      }`,
    });
  // 下载病例单
  downloadCases = (subjectCode: string) => 
    createAxiosHttp<IResult<any>>({
      url: '/data/downloadCases',
      params: {
        subjectCode
      }
    })

  // 修改受试者信息
  updateSubject =  (data: any) => 
    createAxiosHttp<IResult<any>>({
      method: "post",
      url: `/data/report/subject/updateMobile`,
      data,
  })

  // 检查提醒、用药提醒
 remindSubject =  (data: any) => 
  createAxiosHttp<IResult<any>>({
      method: "post",
      url: `data/report/remindSubject/sms`,
      data,
  })


  // 上传量表图片
  scaleUpload = (data: any) => createAxiosHttp<IResult<any>>({
    method: "post",
    url:`data/report/scale/upload`,
    data
  })  
}